import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["colspan"]

import WidgetItem from '@/components/WidgetItem/index.vue'
import { isBoolean } from '@/utils/index';
import { PropType } from 'vue'


const __default__ = {
  name: "FormItem"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  formItem: {
    type: Array as PropType<FormItemType[]>,
    default: []
  },
  formData: {
    type: Object,
    default: {}
  },
  formatData: {
    type: Function
  }
},
  setup(__props) {

const props = __props;



const controller = (item: FormItemType) => {
  const { hide, controller } = item
  if(isBoolean(hide)) {
    return hide
  }
  return controller ? controller(props.formData[item.prop], props.formData,item) : true
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.formItem || []), (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (controller(item))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("td", {
                class: _normalizeClass({'field-required-before': item.required ?? item.rules})
              }, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 3),
              (item.tdSlot)
                ? _renderSlot(_ctx.$slots, "tdSlot", {
                    key: 0,
                    item: item
                  })
                : (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    colspan: item.colspan,
                    class: _normalizeClass(item.tdClass)
                  }, [
                    _createVNode(_component_el_form_item, {
                      prop: item.prop,
                      rules: item.rules
                    }, {
                      default: _withCtx(() => [
                        (item.itemSlot)
                          ? _renderSlot(_ctx.$slots, "itemSlot", _normalizeProps(_mergeProps({ key: 0 }, item)))
                          : _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 1 }, item)), () => [
                              _createVNode(WidgetItem, {
                                "widget-config": item,
                                "widget-data": __props.formData,
                                "format-data": __props.formatData
                              }, null, 8, ["widget-config", "widget-data", "format-data"])
                            ])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"])
                  ], 10, _hoisted_1))
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}
}

})